import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                {/* Basic SEO */}
                <title>Hotels in UAE | UAE Discounted Hotels</title>

                <meta
                    name="description"
                    content="Browse discounted hotels, luxury resorts, budget stays, apartments, and affordable accommodations across Dubai, Abu Dhabi, Sharjah, Ras Al Khaimah, Ajman, Fujairah, and the UAE."
                />

                <meta
                    name="keywords"
                    content="UAE hotels, discounted hotels UAE, Dubai hotels, Abu Dhabi hotels, Sharjah hotels, Ras Al Khaimah hotels, Ajman hotels, Fujairah hotels, budget hotels UAE, luxury hotels UAE, hotel deals UAE"
                />

                <meta name="robots" content="index, follow" />
                <meta name="author" content="UAE Discounted Hotels" />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://uaediscountedhotels.com/hotels"
                />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="UAE Discounted Hotels" />
                <meta property="og:locale" content="en_US" />

                <meta
                    property="og:title"
                    content="Hotels in UAE | UAE Discounted Hotels"
                />

                <meta
                    property="og:description"
                    content="Find the best hotel deals and discounted stays across Dubai, Abu Dhabi, Sharjah, and the UAE."
                />

                <meta
                    property="og:url"
                    content="https://uaediscountedhotels.com/hotels"
                />

                <meta
                    property="og:image"
                    content="https://uaediscountedhotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in UAE | UAE Discounted Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Browse discounted hotels, luxury resorts, budget accommodations, and exclusive hotel deals across the UAE."
                />

                <meta
                    name="twitter:image"
                    content="https://uaediscountedhotels.com/images/default-og.png"
                />
            </Helmet>

            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}